import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { filter, map, Observable } from 'rxjs';
import { MainMenuTreeItem } from '@nx-icilalune/data/icilalune/types';
import { SECONDARY_MENU } from '@nx-icilalune/data/icilalune/tokens';
import { Tree } from '@nx-icilalune/drupal-types';
import { RouterLinkWithHref } from '@angular/router';
import { PwaService } from '@nx-icilalune/icilalune/pwa';
import { SvgIconComponentModule } from '@nx-icilalune/icilalune/media';
import { LetModule } from '@ngrx/component';

@Component({
  selector: 'sh-ui-settings-link',
  standalone: true,
  imports: [
    CommonModule,
    RouterLinkWithHref,
    SvgIconComponentModule,
    LetModule,
  ],
  template: ` <ng-container
    *ngrxLet="settingsFirstMenuItem$; let settingsFirstMenuItem"
  >
    <ng-container *ngIf="settingsFirstMenuItem">
      <a [routerLink]="settingsFirstMenuItem.path">
        <ng-container *ngrxLet="pwaService.installed$; let appInstalled">
          <ng-container *ngrxLet="pwaService.canInstall$; let canInstall">
            <!--<ng-container *ngIf="!appInstalled && canInstall">
              <span class="to-install-indicator"></span>
            </ng-container>-->
          </ng-container>
        </ng-container>
        <i2l-svg-icon icon="info"></i2l-svg-icon>
      </a>
    </ng-container>
  </ng-container>`,
  styleUrls: ['./settings-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsLinkComponent {
  settingsFirstMenuItem$: Observable<MainMenuTreeItem | undefined> =
    this.secondaryMenu$.pipe(
      filter((secondaryMenu) => !!secondaryMenu),
      map((secondaryMenu) => secondaryMenu?.items?.[0])
    );

  constructor(
    @Inject(SECONDARY_MENU)
    protected secondaryMenu$: Observable<Tree<MainMenuTreeItem>>,
    protected pwaService: PwaService
  ) {}
}
